export const customerStatuses = {
  active: 'Active',
  canceled: 'Canceled-Inactive',
}
